import React, { useState } from "react";
import classNames from "classnames";
export const Image = ({ src, alt, title }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isError, setIsError] = useState(false);
    return (React.createElement("div", { className: classNames({
            ["lazyload"]: true,
            ["loaded"]: isLoaded,
            ["d-none"]: isError,
        }) },
        React.createElement("img", { src: src, alt: alt, title: title, onLoad: () => {
                setIsLoaded(true);
            }, onError: () => {
                setIsError(true);
            } })));
};
